module.exports = __webpack_public_path__ + "img/study_heroes_bg01.14d63763.png";